import van from "vanjs-core";
import {getRandomInt, getSum} from "./tools/tools";
import {resolve} from "chart.js/helpers";

const BASE_URL = 'https://fve-production.prg.aero/ene-public';

const fetchFromEnergisPublic = async (ekod, endpoint='/getLast', period='min') => {
    const queryParams = new URLSearchParams({node: ekod, period: period});
    try {
        const request = await fetch(`${BASE_URL}${endpoint}?` + queryParams.toString(), {
            method: 'GET',
        });

        return await request.json();
    } catch (e) {
        return null;
    }
}

// Daily energy / Denni produkce
export const energyAmount = van.state('—');
export const energyUnit = van.state('kWh');

const fetchTodaysEnergyAmount = async () => {
    const requestResult = await fetchFromEnergisPublic(21001002, '/getInterval', 'day');
    if(requestResult?.length) {
        for (let index = requestResult[0].data?.length - 1; index >= 0; index--) {
            const item = requestResult[0].data[index];
            if (item.value) {
                const value = parseFloat(item.value);
                if (value < 10) {
                    energyAmount.val = Math.round(value * 1000 * 100) / 100;
                    energyUnit.val = 'kWh';
                    break;
                } else {
                    energyAmount.val = Math.round(value * 100) / 100;
                    energyUnit.val = 'MWh';
                    break;
                }
            }
        }
    }

    setTimeout(() => fetchTodaysEnergyAmount(), 600 * 1000);
}

// Total energy / Celkova produkce
const staticEnergyAmount = van.state(0);
export const energyTotalAmount = van.state(staticEnergyAmount.val);

const fetchTotalEnergyAmount = async () => {
    const requestResult = await fetchFromEnergisPublic(21001001, '/getInterval', 'mon');
    if(requestResult?.length) {
        for (let index = requestResult[0].data?.length - 1; index >= 0; index--) {
            const item = requestResult[0].data[index];
            if (item.value) {
                const value = parseFloat(item.value);
                energyTotalAmount.val = Math.round((value + staticEnergyAmount.val) * 100) / 100;
                setEcoConstants(Math.round((value) * 100) / 100);
                break;
            }
        }
    }

    setTimeout(() => fetchTotalEnergyAmount(), 600 * 1000);
}

// Total CO2 saved + prepocty na stromy, auto, pocitac
export const baseCO2 = van.state(0);
export const energySaved = van.state(0);
export const treesSaved = van.state(0);
export const carYears = van.state(0);
export const computersRan = van.state(0);

const convertTonsOfCO2ToTrees = (tons) => {
    return Math.round(tons / 0.8);
}

const convertTonsOfCO2CarYears = (tons) => {
    return Math.round(tons / 2.1);
}

const convertTonsOfCO2ToComputers = (totalEnergy) => {
    return Math.round(totalEnergy * 1000 / 500);
}

/*
21001001 * koef1 -> 21001090 tun CO2
21001001 * koef2 -> 21001091 stromů
21001001 * koef3 -> 21001092 aut
21001001 * koef4 -> 21001093 počítačů
 */

// Area plant / osazena plocha
export const areaPlant = van.state(0);

// Jmenovity vykon / Nominal power
export const nominalPower = van.state(0);

// Temperature / Teplota
export const temperature = van.state(0);

const fetchTemperature = async () => {
    const requestResult = await fetchFromEnergisPublic(36000002, '/getInterval', 'qhr');
    if(requestResult?.length) {
        for (let index = requestResult[0].data?.length - 1; index >= 0; index--) {
            const item = requestResult[0].data[index];
            if (item.value) {
                const value = parseFloat(item.value);
                temperature.val = value;
                break;
            }
        }
    }

    setTimeout(() => fetchTemperature(), 600 * 1000);
}
// Existuje nejaky uzel/senzor pro fetch? nebo to brat z nejakeho public weather API?
// Temperature / Teplota

export const chart = van.state(null);


// Chart data, fetchovat z /getInterval o par hodnot z dnesni vyroby?
export const initialChartData = van.state([]);
export const initialChartLabels = van.state([]);

export const fetchChartData = async () => {
    const response = fetchFromEnergisPublic(21001002, '/getInterval', 'hr');
    response.then((data) => {
        const intervalData = data?.[0]?.data;
        const iterations = intervalData?.length >= 10 ? 10 : intervalData?.length;
        const chartData = [];
        const chartLabels = []

        for (let i = intervalData?.length - 1; i >= (intervalData?.length - iterations); i--) {
            chartData.push(parseFloat(intervalData[i]?.value) * 1000);
            chartLabels.push(intervalData[i].datetime.replace(/^\d+-\d+-\d+\s/, ''));
        }

        if (chartData?.length === 0 && chartLabels.length === 0) {
            chartData.push(...["0", "0", "0"]);
            chartLabels.push(...["10kWh", "20kWh", "30kWh"]);
        }

        initialChartData.val = chartData;
        initialChartLabels.val = chartLabels;

        if (chart.val) {
            chart.val.data.labels = chartLabels.reverse();
            chart.val.data.datasets[0].data = chartData.reverse();
            chart.val.options.scales.y.max = Math.max(...chartData) + 10;
            chart.val.update();
        }
    });

    setTimeout(async () => await fetchChartData(), 600 * 1000);
}

// Aktualni produkce + procenta + hodnota pro posouvani grafu
export const percentageText = van.state(0);
export const graphValue = van.state(0);
export const smGraphValue = van.state(0);
export const powerProductionValue = van.state(0);

const getMaxPower = () => {
    if (powerProductionValue.val !== 0) {
        return typeof nominalPower.val === 'number' || typeof nominalPower.val === 'object' ? getSum(nominalPower.val) : powerProductionValue.val;
    }
    return 10;
}

const setPercentageOnGraph = (percentage) => {
    percentageText.val = percentage;
    if (percentage) {
        graphValue.val = 565.48 - percentage * 500.48 / 100;
        smGraphValue.val = 565.48 - percentage * 447.48 / 100;
    } else {
        graphValue.val = 565.48;
        smGraphValue.val = 565.48;
    }
}

const fetchPowerProductionAmount = async () => {
    const requestResult = await fetchFromEnergisPublic(21001009, '/getInterval', 'qhr');
    if(requestResult?.length) {
        for (let index = requestResult[0].data?.length - 1; index >= 0; index--) {
            const item = requestResult[0].data[index];
            if (item.value) {
                const value = Math.round(parseFloat(item.value) * 100) / 100;
                powerProductionValue.val = value >= 0 ? value : 0;
                setPercentageOnGraph(Math.round(powerProductionValue.val / getMaxPower() * 100));
                break;
            }
        }
    }

    setTimeout(() => fetchPowerProductionAmount(), 600 * 1000);
}

export const authorName = van.state("Jméno Příjmení");
export const imageUrl = van.state(null);
export const latestEmissionFactor = van.state(0);

const fetchConf = async () => {
    const response = await fetch("/conf-files/config.json");
    const jsonText = await response.text();
    const data = JSON.parse(jsonText);

    if (data.author_name) {
        authorName.val = data.author_name;
    }

    if (data.nominal_power) {
        nominalPower.val = parseFloat(data.nominal_power);
    }

    if (data.area_plant) {
        areaPlant.val = parseFloat(data.area_plant);
    }

    const EmissionFactors = data.emission_factors ?? {"2025": 0.3};
    const LatestEmissionValue = EmissionFactors[Math.max(...Object.keys(EmissionFactors).map(Number))];
    latestEmissionFactor.val = LatestEmissionValue;

    if (data.overall_power) {
        const PowerResult = data.overall_power;
        if (typeof PowerResult === "number") {
            staticEnergyAmount.val = parseFloat(data.overall_power);
            energyTotalAmount.val = parseFloat(data.overall_power);
        } else if (typeof PowerResult === "object") {
            const sum = Object.values(data.overall_power).reduce((acc, v) => acc + v, 0);
            staticEnergyAmount.val = parseFloat(sum);
            energyTotalAmount.val = parseFloat(sum);

            var co2base = 0;

            for (const [key, value] of Object.entries(data.overall_power)) {
                const Multiplier = EmissionFactors[key] ?? LatestEmissionValue;
                co2base += value * Multiplier;
            }

            baseCO2.val = Math.round(co2base * 100) / 100;

        } else {
            staticEnergyAmount.val = parseFloat(0);
            energyTotalAmount.val = parseFloat(0);
        }
    }

    if (data.image_name) {
        imageUrl.val = `/media/images/${data.image_name}`;
    }
    resolve(0);
}

const setEcoConstants = (energy) => {
    energySaved.val = Math.round(
        (baseCO2.val + energy * latestEmissionFactor.val) * 100
    ) / 100;
    console.log(baseCO2.val, energy * latestEmissionFactor.val);
    treesSaved.val = convertTonsOfCO2ToTrees(energySaved.val);
    carYears.val = convertTonsOfCO2CarYears(energySaved.val);
    computersRan.val = convertTonsOfCO2ToComputers(energyTotalAmount.val);
}

const prepareVariables = async () => {
    fetchConf().then(() => {
        fetchTodaysEnergyAmount();
        fetchTotalEnergyAmount();
        fetchTemperature();
        fetchPowerProductionAmount();
    });
}

prepareVariables();